import { IsoProjection } from "./IsoProjection";
import { TopDownProjection } from "./TopDownProjection";
import { ObliqueProjection } from "./ObliqueProjection";
import type { Projection, ProjectionKind } from "./Projection";

export type { Projection, ScreenPos, WorldPos, ProjectionKind } from "./Projection";
export { IsoProjection } from "./IsoProjection";
export { TopDownProjection, TOPDOWN_TILE } from "./TopDownProjection";
export { ObliqueProjection, OBLIQUE_TILE } from "./ObliqueProjection";

export function projectionFor(kind: ProjectionKind | undefined): Projection {
  switch (kind) {
    case "topdown":
      return new TopDownProjection();
    case "oblique":
      return new ObliqueProjection();
    case "iso":
    default:
      return new IsoProjection();
  }
}
